module.exports = __webpack_public_path__ + "static/media/92180011-neTzwSgs.69488d9f.JPG";